<template>
  <div class="wrapper">
    <TopNavbar/>
    <Content/>
  </div>
</template>

<script>
import Content from '@/pages/layout/Content';
import TopNavbar from '@/pages/layout/TopNavbar';

export default {
  components: {
    Content,
    TopNavbar,
  },
  methods: {
    scrollToTop() {
      const container = this.$el.querySelector('.main-panel');
      container.scrollTop = 0;
    },
  },
  // data() {
  //   return {
  //
  //   };
  // },
};
</script>



// WEBPACK FOOTER //
// src/pages/layout/index.vue